<template>
  <div class="tw-relative">
    <history-common
      v-if="selectedMsp"
      :tier="tierType"
      :tier_id="selectedMsp.id"
      class="tw-mb-6"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import HistoryCommon from "@/views/Common/History";

import { TIER } from "@/constants";

export default {
  components: {
    HistoryCommon,
  },
  data() {
    return {
      tierType: TIER.msps,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },

  async mounted() {
    this.setPageTitle(this.$t("History"));
    this.setPageSubtitle([
      this.$t(
        "Search and view recent messages for your domains to troubleshoot in realtime"
      ),
    ]);
    if (!this.selectedMsp) {
      this.$router.push("/logout");
    }
  },
};
</script>
